import { AttributeTypeEnum } from "@aichat/types/socket/attribute.types";

export const normalizeAttributeType = (type: string) => {
  /* note: There are string and boolean types that should not exist, so we need to normalize the attribute type.
    Currently, the backend cannot remove them from the database since it's already in production. */
  const shouldNormalize = type === "string" || type === "boolean";
  const normalizedType = shouldNormalize ? AttributeTypeEnum.TEXT : type;
  return normalizedType as AttributeTypeEnum;
};

const AttributeTypeValidators: Record<
  AttributeTypeEnum,
  (value: unknown) => boolean
> = {
  [AttributeTypeEnum.STRING]: (value) => typeof value === "string",
  [AttributeTypeEnum.TEXT]: (value) => typeof value === "string",
  [AttributeTypeEnum.PHONE]: (value) => typeof value === "string",
  [AttributeTypeEnum.EMAIL]: (value) =>
    typeof value === "string" && /^\S+@\S+\.\S+$/.test(value),
  [AttributeTypeEnum.NUMBER]: (value) =>
    typeof value === "number" && !isNaN(value),
  [AttributeTypeEnum.DATE]: (value) => {
    if (value instanceof Date && !isNaN(value.getTime())) return true;
    if (typeof value === "string" && !isNaN(Date.parse(value))) return true;
    return false;
  },
  [AttributeTypeEnum.TIME]: (value) => {
    if (typeof value !== "string") return false;
    const regex24h = /^([01]\d|2[0-3]):([0-5]\d)$/;
    const regex12h = /^(0?[1-9]|1[0-2]):([0-5]\d) ?([AaPp][Mm])$/;
    return regex24h.test(value) || regex12h.test(value);
  },
};

export function isValidAttributeValue(
  type: AttributeTypeEnum,
  value: unknown,
): boolean {
  const validator = AttributeTypeValidators[type];
  return validator ? validator(value) : false;
}
